import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { aosColor, IconComponent, IconSize } from '@ui/aos-lib';
import { Observable } from 'rxjs';
import { BreadcrumbsService } from './breadcrumbs.service';
import { Breadcrumb } from './breadcrumbs.types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'aos-breadcrumbs',
  imports: [AsyncPipe, RouterLink, IconComponent, TranslateModule, NgOptimizedImage],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BreadcrumbsService]
})
export class BreadcrumbsComponent {
  readonly breadcrumbsService = inject(BreadcrumbsService);

  protected readonly breadcrumbs$: Observable<Breadcrumb[]> = this.breadcrumbsService.breadcrumbs$;
  protected readonly iconSize = IconSize.MD;
  protected readonly color = aosColor.grayscale300;
}
